import { IModal } from '@app/interfaces/modal';
import * as modernizr from "modernizr";
import { IDisposable } from '@app/interfaces/disposable';

export class ModalContainerComponent {
    modalStack: IModalContext[];

    constructor(private element: HTMLElement) {
        this.modalStack = [];

        this.element.addEventListener("click", ev => {
            const currentModal = this.modalStack[this.modalStack.length - 1];

			if (!$(ev.target!).hasClass("modal__corner-close-button")) {
				if (!currentModal || $(ev.target!).closest($(currentModal.modalElements)).length > 0) {
					return;
				}
			}
			
            if (!currentModal.modal.shouldCloseModal || currentModal.modal.shouldCloseModal()) {
                this.popIfActive(currentModal.modal);
            }
        })
    }

    push(modal: IModal) {
        const elements = modal.render();

        const context = {
            modal: modal,
            modalElements: elements,
            renderedElements: this.wrapModalElement(elements),
            onCloseSubscription: modal.onClose$.subscribe(() => {
                this.popIfActive(modal);
            })!
        };

        this.modalStack.push(context);
        $(this.element).append(context.renderedElements);

        this.setContainerVisibility(true);
    }

    pop() {
        const context = this.modalStack.pop();

        if (!context) {
            return;
        }

        $(context.renderedElements).detach();
        context.onCloseSubscription.dispose();

        if (this.modalStack.length === 0) {
            this.setContainerVisibility(false);
        }
    }

    popIfActive(modal: IModal) {
        const currentModal = this.modalStack[this.modalStack.length - 1];

        if (currentModal.modal === modal) {
            this.pop();
        }
    }

    private wrapModalElement(elements: HTMLElement[]): HTMLElement[] {
        if (modernizr.flexbox) {
            return elements;
        }

        const $root = $(`<div class="modal-container__wrapper"><div class="modal-container__vertical-align-wrapper"><div class="modal-container__horizontal-align-wrapper"><span></span></div></div></div>`);

        $root.find("span").replaceWith(elements);

        return $root.get();
    }

    private setContainerVisibility(toggle: boolean) {
        $(this.element).toggleClass("modal-container--visible", toggle);
        $(document.body).toggleClass("modal-container-open", toggle);
    }
}

interface IModalContext {
    modal: IModal;
    modalElements: HTMLElement[];
    renderedElements: HTMLElement[];
    onCloseSubscription: IDisposable;
}